<lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>
<div class="content">
    <h4>Credit Report</h4>
    <div class="Vert-15"></div>

    <mat-dialog-content>
        <form [formGroup]="creditReportForm">
            <div class="row">
                <div class="col-12">
                    <mat-form-field appearance="outline" floatLabel="always" title="Report Type">
                        <mat-label>Report Type</mat-label>
                        <mat-select formControlName="reportType" placeholder="None">
                            <mat-option *ngIf="isHardPull || isBorrowersChoicePull || hasNoCreditReport" value="HardPull">Hard Pull</mat-option>
                            <mat-option *ngIf="isSoftPull || isBorrowersChoicePull" value="SoftPull">Soft Pull</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <a style="margin-top: -15px; margin-bottom:10px" (click)="openCreditInfoModal()">What does this mean?</a>
            </div>
            <h6>Borrower</h6>
            <div class="row" formGroupName="borrowers">
                <div class="col-12">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="firstName">
                    </mat-form-field>
                </div>

                <div class="col-12">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Middle Name</mat-label>
                        <input matInput formControlName="middleName">
                    </mat-form-field>
                </div>

                <div class="col-12">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="lastName">
                    </mat-form-field>
                </div>

                <div class="col-6">
                    <lgv-ssn-input [ssnInputControl]="ssnBorrowerCtrl"></lgv-ssn-input>
                </div>

                <div class="col-6">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput [matDatepicker]="picker" placeholder="Choose a date" formControlName="birthDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <mat-label style="font-size: 14px; color: #737373">Are you applying for a co-borrower? *</mat-label>
                    <br>
                    <mat-radio-group aria-label="Select an option" formControlName="isApplyingForCoborrower">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div formGroupName="borrowers" *ngIf="creditReportForm.controls.isApplyingForCoborrower.value">
                <div class="Vert-15"></div>
                <h6>Co-borrower</h6>
                <div class="row" formGroupName="coBorrower">
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName">
                        </mat-form-field>
                    </div>

                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Middle Name</mat-label>
                            <input matInput formControlName="middleName">
                        </mat-form-field>
                    </div>

                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName">
                        </mat-form-field>
                    </div>

                    <div class="col-6">
                        <lgv-ssn-input [ssnInputControl]="ssnCoborrowerCtrl"></lgv-ssn-input>
                    </div>

                    <div class="col-6">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Date of Birth</mat-label>
                            <input matInput [matDatepicker]="picker2" placeholder="Choose a date" formControlName="birthDate">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="Vert-15"></div>
            <h6>Current Address</h6>
            <div formGroupName="borrowers">
                <div class="row" formGroupName="currentAddress">
                    <div class="col-12">
                        <lus-address-auto-complete [addressControl]="currentAddressStreetCtrl"
                            [cityControl]="currentAddressCityCtrl" [stateControl]="currentAddressStateCtrl"
                            [zipControl]="currentAddressZipCtrl" [showAllFields]="false"
                            [streetOnly]="true"></lus-address-auto-complete>
                    </div>
    
                    <div class="col-5">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>City</mat-label>
                            <input matInput formControlName="city">
                        </mat-form-field>
                    </div>
    
                    <div class="col-3">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>State</mat-label>
                            <input matInput formControlName="state">
                        </mat-form-field>
                    </div>
    
                    <div class="col-4">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Zip</mat-label>
                            <input matInput formControlName="zipCode">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <mat-label style="font-size: 14px; color: #737373">I have lived at my current address less than two
                        years</mat-label>
                    <br>
                    <mat-radio-group aria-label="Select an option" formControlName="isCurrentAddressLessThanTwoYears">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="Vert-15"></div>
            </div>

            <div formGroupName="borrowers">
                <div class="row" formGroupName="previousAddresses"
                *ngIf="creditReportForm.controls.isCurrentAddressLessThanTwoYears.value">
                <div class="col-12">
                    <lus-address-auto-complete [addressControl]="previousAddressStreetCtrl"
                        [cityControl]="previousAddressCityCtrl" [stateControl]="previousAddressStateCtrl"
                        [zipControl]="previousAddressZipCtrl" [showAllFields]="false"
                        [streetOnly]="true"></lus-address-auto-complete>
                </div>

                <div class="col-5">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city">
                    </mat-form-field>
                </div>

                <div class="col-3">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>State</mat-label>
                        <input matInput formControlName="state">
                    </mat-form-field>
                </div>

                <div class="col-4">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Zip</mat-label>
                        <input matInput formControlName="zipCode">
                    </mat-form-field>
                </div>
            </div>
            </div>
            

            <div class="Vert-15"></div>
            <h6>Credit Card</h6>
            <div class="row">
                <div class="col-12">
                    <mat-label style="font-size: 14px; color: #737373">Same As Current Address *</mat-label>
                    <br>
                    <mat-radio-group aria-label="Select an option" formControlName="isBillingSameAsCurrentAddress">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="Vert-15"></div>
            </div>
            <div formGroupName="billingInformation">
                <div class="row" formGroupName="address"
                    *ngIf="!creditReportForm.controls.isBillingSameAsCurrentAddress.value">
                    <div class="col-12">
                        <lus-address-auto-complete [addressControl]="ccAddressStreetCtrl"
                            [cityControl]="ccAddressCityCtrl" [stateControl]="ccAddressStateCtrl"
                            [zipControl]="ccAddressZipCtrl" [showAllFields]="false"
                            [streetOnly]="true"></lus-address-auto-complete>
                    </div>

                    <div class="col-5">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>City</mat-label>
                            <input matInput formControlName="city">
                        </mat-form-field>
                    </div>

                    <div class="col-3">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>State</mat-label>
                            <input matInput formControlName="state">
                        </mat-form-field>
                    </div>

                    <div class="col-4">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Zip</mat-label>
                            <input matInput formControlName="zipCode">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row" *ngIf="!!(creditReportTotalCost$ | async)">
                    <div class="col-12" style="margin-bottom: 10px;">
                        <mat-label>Total Cost (Incl. Fees)</mat-label> <br>
                        <mat-label>$ {{creditReportTotalCost$ | async}}</mat-label>
                    </div>
                </div>

                <div class="row">

                    <div class="col-11" formGroupName="creditCard">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Card Number</mat-label>
                            <input  matInput formControlName="cardNumber" ccNumber #ccNumber="ccNumber" minlength="17" maxlength="19">
                        </mat-form-field>
                    </div>
                    <div class="col-1">
                        <span *ngIf="(ccNumber?.resolvedScheme$ | async) == 'visa'"><fa-icon [icon]="['fab','cc-visa']" class="primary-color" style="font-size: 34px; margin-left: -10px"></fa-icon></span>
                        <span *ngIf="(ccNumber?.resolvedScheme$ | async) == 'amex'"><fa-icon [icon]="['fab','cc-amex']" class="primary-color" style="font-size: 34px; margin-left: -10px"></fa-icon></span>
                        <span *ngIf="(ccNumber?.resolvedScheme$ | async) == 'mastercard'"><fa-icon [icon]="['fab','cc-mastercard']" class="primary-color" style="font-size: 34px; margin-left: -10px"></fa-icon></span>
                        <span *ngIf="(ccNumber?.resolvedScheme$ | async) == 'dinersclub'"><fa-icon [icon]="['fab','cc-diners-club']" class="primary-color" style="font-size: 34px; margin-left: -10px"></fa-icon></span>
                        <span *ngIf="(ccNumber?.resolvedScheme$ | async) == 'discover'"><fa-icon [icon]="['fab','cc-discover']" class="primary-color" style="font-size: 34px; margin-left: -10px"></fa-icon></span>
                    </div>
                    <mat-error style="margin-top: -20px; font-size:12px;" *ngIf="!!ccCardNumberCtrl?.errors && ccCardNumberCtrl?.touched ">
                        Please enter a valid card number.
                    </mat-error>
                </div>
                <div class="row" formGroupName="creditCard">
                    <div class="col-7">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Expiration date</mat-label>
                            <input id="cc-exp-date" type="tel" autocomplete="cc-exp" ccExp matInput
                                formControlName="expiration">
                        </mat-form-field>
                        <mat-error style="margin-top: -20px; font-size:12px;" *ngIf="!!ccExpirationCtrl?.errors && ccExpirationCtrl?.touched">
                            Please enter a valid expiration date as DD / YYYY.
                        </mat-error>
                    </div>
                    <div class="col-5">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>CVV</mat-label>
                            <input id="cc-cvc" type="tel" autocomplete="off" matInput formControlName="cvv" minlength="3"
                                maxlength="4" ccCVC>
                        </mat-form-field>
                        <mat-error style="margin-top: -20px; font-size:12px;" *ngIf="!!ccCvvCtrl?.errors && ccCvvCtrl?.touched">
                            Please enter a valid cvv.
                        </mat-error>
                    </div>
                </div>
            </div>

            <div class="Vert-10"></div>
            <h4>Terms & Agreements</h4>
            <div class="row">
                <div class="col-12">
                    <mat-checkbox formControlName="creditTerms">I/We give authorization to run a credit check on</mat-checkbox>
                    <br>
                    <span style="margin-left: 32px;">financial history</span>
                </div>
                <br>
                <a style="padding-left: 35px; font-weight: 700;" (click)="openViewTermsModal('creditTerms')">View Terms</a>
                <div class="Vert-15"></div>
            </div>
            <p><i>Optional, but strongly recommended:</i></p>
            <div class="row">
                <div class="col-12">
                    <mat-checkbox formControlName="thirdPartyTerms">Opt out of 3rd party solicitations. Click below </mat-checkbox>
                    <br>
                    <span style="margin-left: 32px;">to protect yourself from scams.</span>
                </div>
                <br>
                <a style="padding-left: 35px; font-weight: 700;"
                    target="_blank" href="https://www.optoutprescreen.com/">https://www.optoutprescreen.com/</a>
                <div class="Vert-15"></div>
            </div>
        </form>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button mat-stroked-button class="btn btn-secondary"  (click)="dialogRef.close({action: false})">Cancel</button>
        <button mat-button class="btn btn-primary" [disabled]="!creditReportForm.valid || !isValid(creditReportForm?.value)"
            (click)="onSubmit()">Submit</button>
    </div>
</div>